module.exports = __webpack_public_path__ + "media/images/icons/filled/facebook-5492d7141bac18d6b9d4f9f16182a35f.svg";